export default {"src":"/_next/static/media/CFCC.b139fd05.svg","height":32,"width":97,"blurWidth":0,"blurHeight":0};